import React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { QRCodeSVG } from "qrcode.react";

type Props = {
  value: string;
  frameSize?: number; // equivalente ao size
  backgroundColor?: string;
  dotColor?: string;
  contentStyle?: ViewStyle;
};

export const QrCodeSvg = ({
  value,
  frameSize = 180,
  backgroundColor = "transparent",
  dotColor = "white",
  contentStyle,
}: Props) => {
  return (
    <View
      style={[
        styles.container,
        { width: frameSize, height: frameSize },
        contentStyle,
      ]}
    >
      <QRCodeSVG
        value={value || ""}
        size={frameSize}
        bgColor={backgroundColor}
        fgColor={dotColor}
        includeMargin={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
  },
});
